<ng-container *ngIf="!item.hidden">
  <!-- normal collapse -->
  <a
    class="nav-link"
    *ngIf="!item.url && !item.function"
    (click)="toggleOpen($event)"
    (keydown.enter)="toggleOpen($event)"
    (keydown.space)="toggleOpen($event)"
    tabindex="0"
    matRipple
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
  <!-- item.url -->
  <a
    class="nav-link"
    *ngIf="item.url && !item.function"
    (click)="toggleOpen($event)"
    [routerLink]="[item.url]"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
    matRipple
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
  <!-- item.function -->
  <span
    class="nav-link"
    *ngIf="!item.url && item.function"
    (click)="toggleOpen($event);item.function()"
    (keydown.enter)="toggleOpen($event);item.function()"
    (keydown.space)="toggleOpen($event);item.function()"
    tabindex="0"
    matRipple
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </span>
  <!-- item.url && item.function -->
  <a
    class="nav-link"
    *ngIf="item.url && item.function"
    (click)="toggleOpen($event);item.function()"
    [routerLink]="[item.url]"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
    matRipple
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
  <ng-template #itemContent>
    <mat-icon
      class="nav-link-icon"
      *ngIf="item.icon"
    >{{item.icon}}</mat-icon>
    <span
      class="nav-link-title"
      [translate]="item.translate"
    >{{item.title}}</span>
    <span
      class="nav-link-badge"
      *ngIf="item.badge"
      [translate]="item.badge.translate"
      [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}"
    >
      {{item.badge.title}}
    </span>
    <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
  </ng-template>
  <div
    class="children"
    [@slideInOut]="isOpen"
  >
    <ng-container *ngFor="let item of item.children">
      <app-nav-vertical-item
        *ngIf="item.type==='item'"
        [item]="item"
      ></app-nav-vertical-item>
      <app-nav-vertical-collapse
        *ngIf="item.type==='collapse'"
        [item]="item"
      ></app-nav-vertical-collapse>
      <!-- <nk-nav-vertical-group *ngIf="item.type=='group'"
        [item]="item"></nk-nav-vertical-group> -->
    </ng-container>
  </div>
</ng-container>
